import Super from '@simplepractice/ember-messaging-client/models/messaging-conversation';

export default Super.extend({});
